// @ts-check

class Module {
  constructor({
    items,
    readMoreBtn,
    maxArticles,
    element,
    itemsFirstTime = null
  }) {
    this.dom = {
      $listing: items,
      $readMoreBtn: readMoreBtn
    };
    this.el = element;
    this.maxArticles = maxArticles;
    this.total = itemsFirstTime ?? maxArticles;

    this.handleReadMore(true);
  }

  handleReadMore(firstTime = false) {
    if (firstTime) {
      this.hide(this.total);
    } else {
      this.total += this.maxArticles;
      this.hide(this.total);
    }
  }

  hide(total) {
    if (total >= this.dom.$listing.length) {
      this.dom.$readMoreBtn.style.display = 'none';
    } else {
      this.dom.$readMoreBtn.style.removeProperty('display');
    }

    this.dom.$listing.forEach((item, index) => (item.hidden = index >= total));
  }
}

export default Module;
